// src/components/UseCaseList.jsx
import React from 'react';

const UseCaseList = ({ useCases, selectedId, onSelect, onDelete }) => (
  <div style={{ marginBottom: "20px" }}>
    {useCases.map((useCase) => (
      <div
        key={useCase.id}
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          padding: "12px",
          margin: "4px 0",
          borderRadius: "8px",
          background: selectedId === useCase.id ? "var(--primary-coral)" : "var(--light-gray)",
          color: selectedId === useCase.id ? "var(--white)" : "var(--text-dark)",
          cursor: "pointer",
          transition: "var(--transition)"
        }}
      >
        <div 
          onClick={() => onSelect(useCase.id)}
          style={{ flex: 1 }}
        >
          <div style={{ fontWeight: "600", fontSize: "14px" }}>
            {useCase.name} - {useCase.id}
          </div>
          <div style={{ fontSize: "12px", opacity: 0.8 }}>
            {useCase.comments || "Keine Beschreibung"}
          </div>
        </div>
        
        {/* Delete Button */}
        <button
          onClick={(e) => {
            e.stopPropagation();
            if (window.confirm(`Sind Sie sicher, dass Sie "${useCase.name}" löschen möchten?`)) {
              onDelete(useCase.id);
            }
          }}
          style={{
            padding: "6px 8px",
            backgroundColor: "#ff6b6b",
            color: "white",
            border: "none",
            borderRadius: "4px",
            cursor: "pointer",
            fontSize: "12px",
            marginLeft: "8px"
          }}
          title="Use Case löschen"
        >
          🗑️
        </button>
      </div>
    ))}
  </div>
);

export default UseCaseList;
